import { render } from "./PaymethodSelection.vue?vue&type=template&id=0a4a3a34&scoped=true"
import script from "./PaymethodSelection.vue?vue&type=script&lang=js"
export * from "./PaymethodSelection.vue?vue&type=script&lang=js"

import "./PaymethodSelection.vue?vue&type=style&index=0&id=0a4a3a34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a4a3a34"
/* hot reload */
if (module.hot) {
  script.__hmrId = "0a4a3a34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a4a3a34', script)) {
    api.reload('0a4a3a34', script)
  }
  
  module.hot.accept("./PaymethodSelection.vue?vue&type=template&id=0a4a3a34&scoped=true", () => {
    api.rerender('0a4a3a34', render)
  })

}

script.__file = "src/components/checkout/modules/PaymethodSelection.vue"

export default script